import sketchfabModel from "../assets/parts/3dmodel.json"

// Set environment configuration
let envConfig;

// process.env.NODE_ENV is added at build
if (process.env.NODE_ENV) {
    envConfig = require(`./${process.env.NODE_ENV}`).default;
    // add sketchfab details from the assets folder
    envConfig = {...envConfig, ...{ sketchfab: sketchfabModel[process.env.NODE_ENV] }}
}

export default envConfig;



// WEBPACK FOOTER //
// ./src/config/index.js